import React, { useState } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from "../ui/dialog";
import { Button } from "../ui/button";
import { Slider } from "../ui/slider";
import { RotateCw, Crosshair, ZoomIn } from "lucide-react";
import { CropEditor } from "../CropEditor";
import { useT } from "../../lib/i18n";

export default function AdjustDialog({ open, magnet, onClose, onSave }) {
  const { t } = useT();
  const [local, setLocal] = useState(null);
  React.useEffect(() => {
    if (open && magnet) {
      setLocal({
        photo_id: magnet.photo_id,
        cropPos: magnet.cropPos || { x: 0, y: 0 },
        zoom: magnet.zoom || 1,
        rotation: magnet.rotation || 0,
        crop: magnet.crop || null,
      });
    }
  }, [open, magnet]);

  if (!local) return null;
  const patch = (p) => setLocal((s) => ({ ...s, ...p }));

  return (
    <Dialog open={open} onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="max-w-md">
        <DialogHeader><DialogTitle className="font-display">{t("adjust_title")}</DialogTitle></DialogHeader>
        <div data-testid="adjust-crop-editor">
          <CropEditor photo={local} onChange={patch} />
        </div>
        <div className="mt-2 flex items-center gap-3">
          <ZoomIn className="h-4 w-4 text-[hsl(var(--muted-foreground))]" />
          <Slider value={[local.zoom]} min={1} max={3} step={0.01} onValueChange={(v) => patch({ zoom: v[0] })} className="flex-1" data-testid="adjust-zoom-slider" />
        </div>
        <div className="mt-2 grid grid-cols-2 gap-2">
          <Button variant="outline" onClick={() => patch({ rotation: ((local.rotation || 0) + 90) % 360 })} className="h-10 rounded-xl border bg-white" data-testid="adjust-rotate-button"><RotateCw className="mr-1 h-4 w-4" /> {t("rotate")}</Button>
          <Button variant="outline" onClick={() => patch({ cropPos: { x: 0, y: 0 }, zoom: 1, rotation: 0 })} className="h-10 rounded-xl border bg-white"><Crosshair className="mr-1 h-4 w-4" /> {t("reset")}</Button>
        </div>
        <DialogFooter className="mt-3 flex-row gap-2">
          <Button variant="outline" onClick={onClose} className="h-11 flex-1 rounded-xl border bg-white">{t("cancel")}</Button>
          <Button onClick={() => onSave(local)} className="h-11 flex-1 rounded-xl" data-testid="adjust-save-button">{t("save")}</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
